import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import _ from 'lodash';
import classes from '../../PossiblePersons/Analytics/analytics.module.scss';
import AnalyticsChartWrapper from '../../PossiblePersons/Analytics/ChartComtonents/AnalyticsChartWrapper';
import { useQuery } from '../../../../utils/hooks/useQuery';
import api from '../../../../api/api';
import Loader from '../../../_common/Loader/Loader';

const chartTemplate = {
  series: [{
    name: 'Response Time',
    data: [],
  }],
  chart: {
    type: 'area',
    height: 350,
    toolbar: false,
    zoom: {
      enabled: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: 'straight',
  },
  grid: {
    strokeDashArray: 5,
    colors: '#E5E5EF',
  },
  labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
  xaxis: {
    type: 'category',
    labels: {
      style: {
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '16px',
        textAlign: 'center',
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        colors: '#615E83',
      },
    },
  },
  yaxis: {
    // opposite: true,
    min: 0,
    labels: {
      show: true,
      formatter(val) {
        return `${Math.round(val) > 60 ? `${Math.round(val / 60)}m ${Math.round(val) % 60}s` : `${Math.round(val)}s`}`;
      },
      style: {
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '16px',
        textAlign: 'center',
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        colors: '#615E83',
      },
    },
  },
  legend: {
    show: false,
    enabled: false,
  },
};

const thisMonthStartDay = moment().startOf('month').format('YYYY-MM-DD');
const thisMonthEndDate = moment().format('YYYY-MM-DD');
function AverageResponseTime(props) {
  const { query, setQuery } = useQuery();

  const {
    resId, resName, resStart, resEnd,
  } = query;

  const [chart, setChart] = useState(chartTemplate);
  const [loading, setLoading] = useState(false);

  const [healthValue, setHealthValue] = useState(resName || '');

  const [requestData, setRequestData] = useState({
    start: resStart || thisMonthStartDay,
    end: !resStart ? thisMonthEndDate : (resEnd || ''),
    healthPlanId: resId || '',
    healthPlanName: resName || '',
  });

  const {
    start, end, healthPlanId, healthPlanName,
  } = requestData;

  useEffect(() => {
    if (requestData.healthPlanId) {
      (async () => {
        setLoading(true);
        const { data } = await api.getResponseAverageTime({
          startDate: start,
          endDate: end || moment(start).add(1, 'day').format('YYYY-MM-DD'),
          healthPlanId,
        });

        setQuery({
          ...query, resStart: start, resEnd: end, resId: healthPlanId, resName: healthPlanName,
        });

        const dataArray = data.data.map((d) => d.avg);

        setChart((prev) => ({
          ...prev,
          series: [{
            name: 'Response time',
            data: dataArray,
          }],
          yaxis: {
            ...prev.yaxis,
            max: Math.max(...dataArray),
          },
          xaxis: {
            ...prev.xaxis,
            categories: data.data[0].rangeType === 'week'
              ? data.data.map((d) => `${moment(d.startDate).format('MMM DD')} - ${moment(d.endDate).format('MMM DD')}`)
              : data.data[0].rangeType === 'month' ? data.data.map((d) => moment(d.time).format('MMM'))
                : data.data.map((d) => moment(d.time).format('MMM DD')),
          },
        }));

        setLoading(false);
      })();
    }
  }, [requestData]);

  const changeDateAndHealth = (value, path, planName) => {
    setRequestData((prev) => {
      if (path === 'date') {
        return {
          ...prev,
          start: value[0],
          end: value[1],
        };
      }

      return {
        ...prev,
        [path]: value,
        healthPlanName: planName,
      };
    });
  };

  return (
    <AnalyticsChartWrapper
      title="Average response time"
      date={requestData}
      healthValue={healthValue}
      setHealthValue={setHealthValue}
      onChange={changeDateAndHealth}
      className={classes.bottom_chart_analytics}
    >
      {loading
        ? <div className={classes.loader_wrapper}><Loader /></div>

        : _.max(chart?.series?.[0]?.data) === 0 && !loading
          ? <div className={classes.notResult}>No Data Found</div>

          : (
            <Chart
              options={chart}
              series={chart.series}
              height={300}
              type="area"
              width="100%"
            />
          )}
    </AnalyticsChartWrapper>
  );
}

export default AverageResponseTime;
